const experienceData = [
  {
    startDate: "June 2023",
    endDate: "August 2025",
    company: "CIDAR Labs",
    title: "Research Software Engineer",
    description: `Started as a full-time summer intern, continued part-time during the academic year, and returned as a fellow after graduation to complete ongoing projects. Contributed to the development of 3duf, a visual design tool for microfluidic devices, and Neptune, a design automation toolchain, by implementing new features and ensuring compatibility across the workflow.`,
  },
  {
    startDate: "September 2023",
    endDate: "May 2024",
    company: "Langolio",
    title: "Full Stack Developer",
    description: `Collaborated with a team to plan, design, and develop a full-stack app for connecting language 
    learners through real-time chats, fulfilling our client’s objectives and user requirements.`,
  },
  {
    startDate: "January 2022",
    endDate: "May 2023",
    company: "Boston University College of Engineering",
    title: "Teaching Assistant",
    description: `Served as a Teaching Assistant for Engineering Mechanics 1, where I supported students in understanding course 
    material, ran review sessions, and held office hours to provide guidance on assignments and projects.`,
  },
];

export default experienceData;
